import CommonMixin from "@/common/mixins/common-mixin";
import qs from "qs";
import { mixToken } from "@/plugins/common-functions";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      events: {
        status: {},
        error: { error: false, message: "" },
        messages: [],
      },
      connected: false,
      event: null,
    };
  },
  methods: {
    makeUrl(cmd, data) {
      const url =
        this.$apiUrl(cmd) + "?user_token=" + mixToken(this.user.token);
      return data ? `${url}&${qs.stringify(data)}` : url;
    },
    handleSSEData(data) {
      // 这个必须修改成自己的代码。
      if (this.result) {
        this.result.push(data.message);
      }
    },
    connectSSE(cmd, data, done) {
      const vm = this;
      this.events.status = {};
      this.events.error = { error: false, message: "" };
      this.events.messages = [];
      vm.event = new EventSource(vm.makeUrl(cmd, data));
      vm.event.onerror = function (e) {
        console.error("SSE error:", e);
        // 可以在这里添加更多的错误处理逻辑
        vm.events.messages.push("链接错误了!");
        vm.event.close();
        vm.event = null;
        vm.events.error = { error: true, message: "连接错误!" };
        if (done) done();
      };
      vm.event.addEventListener("message", function (e) {
        const data = JSON.parse(e.data);
        if (data.message) vm.events.messages.push(data.message);
        if (data.status)
          vm.events.status = Object.assign({}, vm.events.status, data.status);
        vm.handleSSEData(data);
      });
      vm.event.addEventListener("end", function () {
        vm.event.close();
        vm.event = null;
        if (done) done();
      });
      vm.event.addEventListener("error", function (e) {
        const data = JSON.parse(e.data);
        if (data.message) vm.events.messages.push(data.message);
        vm.event.close();
        vm.event = null;
        vm.events.error = { error: true, message: data.message };
        if (done) done();
      });
    },
    disconnectSSE() {
      if (this.event) this.event.close();
      this.event = null;
    },
  },
  destroyed() {
    this.disconnectSSE();
  },
};
